import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter, input, Input } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.html',
  styleUrls: ['./sidenav.scss'],
  imports: [CommonModule, RouterModule, MatIconModule]
})
export class Sidenav {
  selectedModule: any = null;


  @Input() isExpanded: boolean = true;
  @Output() toggleSidenav = new EventEmitter<boolean>();

  constructor(public route: ActivatedRoute) { }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.toggleSidenav.emit(this.isExpanded);
  }

  toggleModule(modulo: any): void {
      if (this.selectedModule === modulo) {
        this.selectedModule = null;
      } else {
        this.selectedModule = modulo;
      }
    }


}
